module.exports = __webpack_public_path__ + "static/akintan-69b772dd3226f8689a303c4668a3b043.jpg";